// Body visibility: remove "hidden" when page loads, add it again before leaving
function revealPage() {
  document.body.classList.remove('hidden');
}

function hidePage() {
  document.body.classList.add('hidden');
}

function resetPageLoader() {
  var root = document.getElementById('page-loader-root');
  var intro = document.getElementById('page-loader-intro');
  var transition = document.getElementById('page-loader-transition');
  if (root) root.classList.add('page-loader-root--hidden');
  if (intro) intro.classList.remove('is-exiting');
  if (transition) transition.classList.remove('is-visible', 'is-exiting');
}

function restorePageFromCache() {
  revealPage();
  resetPageLoader();
}

// bfcache: pagehide may leave body hidden; pageshow must reveal it again on history.back()
window.addEventListener('pageshow', function(event) {
  if (event.persisted || document.body.classList.contains('hidden')) {
    restorePageFromCache();
  }
});

// LQIP (Low Quality Image Placeholder) blur-up effect
function initLQIP() {
  const lqipImages = document.querySelectorAll('.media-lqip[data-lqip]');
  
  lqipImages.forEach(function(img) {
    // Set LQIP as background immediately for instant visual feedback
    const lqipSrc = img.getAttribute('data-lqip');
    const container = img.closest('.media-container') || img.parentElement;
    
    if (lqipSrc && container) {
      // Preload LQIP for instant display
      const lqipImg = new Image();
      lqipImg.src = lqipSrc;
      
      // Set background immediately (LQIP is tiny, loads almost instantly)
      container.style.backgroundImage = 'url(' + lqipSrc + ')';
      container.style.backgroundSize = 'cover';
      container.style.backgroundPosition = 'center';
      container.style.backgroundRepeat = 'no-repeat';
    }
    
    // When main image loads, remove blur and fade in
    const handleImageLoad = function() {
      img.classList.add('loaded');
      // Remover clase media-lqip
      img.classList.remove('media-lqip');
      // Clean up background image once main image is loaded (memory optimization)
      if (container && container.style.backgroundImage) {
        container.style.backgroundImage = '';
      }
    };
    
    if (img.complete && img.naturalWidth > 0) {
      // Image already loaded
      handleImageLoad();
    } else {
      // Wait for image to load
      img.addEventListener('load', handleImageLoad, { once: true });
      
      // Also handle error case
      img.addEventListener('error', function() {
        // Remove blur even on error to show fallback
        handleImageLoad();
      }, { once: true });
      
      // Fallback: remove blur after timeout even if load event doesn't fire
      setTimeout(function() {
        if (!img.classList.contains('loaded')) {
          handleImageLoad();
        }
      }, 3000);
    }
  });
}

function handleSecondaryNav() {
  document.querySelectorAll('.has-childs').forEach(function(el) {
    el.addEventListener('click', function(e) { 
      e.preventDefault();
      el.parentElement.classList.toggle("show");    
    });
  });
}
  
function setHeaderHeightVar() {
  var header = document.getElementById('header');
  if (header) {
    var height = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', height + 'px');
  }
}

function setViewportHeightVar() {
  const body = document.body;
  
  // Solo aplicar para template-page-collections-shop
  if (body.classList.contains('template-page-collections-shop')) {
    const viewportHeight = window.innerHeight;
    document.documentElement.style.setProperty('--shop-vp-height', viewportHeight + 'px');
  }
}

function calculateImageLinkHeight() {
  const imageLink = document.querySelector('.collection-shop-image-link');
  
  if (!imageLink) {
    return;
  }
  
  const height = imageLink.offsetHeight;
  const width = imageLink.offsetWidth;
  
  document.documentElement.style.setProperty('--image-link-height', height + 'px');
  document.documentElement.style.setProperty('--image-link-width', width + 'px');
  
  return height;
}

function applyShopInfoTriggerClass() {
  const infos = document.querySelectorAll('.collection-shop-info');
  
  // Obtener el valor de la variable CSS --shop-vp-height
  const shopVpHeightValue = getComputedStyle(document.documentElement).getPropertyValue('--shop-vp-height');
  const viewportHeight = parseFloat(shopVpHeightValue);
  const halfViewport = viewportHeight / 2;
  
  infos.forEach((info) => {
    // Obtener el valor de top del elemento
    const topValue = info.style.top;
    const topPixels = parseFloat(topValue);
    
    // Comparar y añadir/remover la clase
    if (topPixels > halfViewport) {
      info.classList.add('collection-shop-info-trigger');
    } else {
      info.classList.remove('collection-shop-info-trigger');
    }
  });
}

// Estado global para sticky monitoring (se mantiene entre llamadas)
let stickyMonitorState = null;

function monitorStickyTriggers() {
  // Inicializar el estado SOLO la primera vez
  if (stickyMonitorState === null) {
    stickyMonitorState = {
      lastStickyState: new Map(),
      initialAdjustmentApplied: new Map(), // Rastrear si ya aplicamos el -15px inicial
      lastRectTop: new Map(),
      lastScrollY: window.scrollY,
      firstStickyDetected: false,
      scrollYWhenFirstSticky: 0,
      adjustmentMultiplier: 0,
      imageLinkHeight: 0
    };

    // Configurar el listener de scroll UNA SOLA VEZ
    window.addEventListener('scroll', checkTriggersSticky, { passive: true });
  }

  // Reinicializar triggers en caso de cambios en el DOM
  const triggers = document.querySelectorAll('.collection-shop-info-trigger');
  triggers.forEach((trigger) => {
    if (!stickyMonitorState.lastStickyState.has(trigger)) {
      stickyMonitorState.lastStickyState.set(trigger, false);
      stickyMonitorState.initialAdjustmentApplied.set(trigger, false);
      stickyMonitorState.lastRectTop.set(trigger, trigger.getBoundingClientRect().top);
    }
  });

  function checkTriggersSticky() {
    const currentScrollY = window.scrollY;
    const scrollDelta = currentScrollY - stickyMonitorState.lastScrollY;
    
    // Si llegamos al top de la página (scrollY === 0), reiniciar todo
    if (currentScrollY === 0 && stickyMonitorState.firstStickyDetected) {
      console.log('🔄 Top de página alcanzado - Reiniciando estado');
      
      // Resetear los ajustes: volver a los valores originales de top
      const infos = document.querySelectorAll('.collection-shop-info');
      infos.forEach((info, index) => {
        // Calcular el top original (sin ajustes)
        let originalTop = 0;
        for (let i = 0; i < index; i++) {
          originalTop += infos[i].offsetHeight;
        }
        info.style.top = originalTop + 'px';
      });
      
      // Reinicializar el estado completamente
      stickyMonitorState = null;
      console.log('✅ Estado reiniciado - Funcionando como nuevo');
      
      // Reinicializar todo de nuevo
      monitorStickyTriggers();
      applyShopInfoTriggerClass();
      return;
    }
    
    const triggers = document.querySelectorAll('.collection-shop-info-trigger');
    
    triggers.forEach((trigger, index) => {
      const rect = trigger.getBoundingClientRect();
      const currentTop = rect.top;
      const prevTop = stickyMonitorState.lastRectTop.get(trigger);
      const wasSticky = stickyMonitorState.lastStickyState.get(trigger);
      const initialAdjustmentDone = stickyMonitorState.initialAdjustmentApplied.get(trigger);
      
      // Calcular cuánto cambió el rect.top en este evento de scroll
      const rectTopDelta = currentTop - prevTop;
      
      // Si el usuario scrolló mucho pero rect.top casi no cambió, es sticky
      const isSticky = scrollDelta !== 0 && Math.abs(rectTopDelta) < 1 && Math.abs(scrollDelta) > 5;
      
      stickyMonitorState.lastRectTop.set(trigger, currentTop);
      
      // Solo ejecutar cuando hay un cambio de estado (no-sticky → sticky)
      if (isSticky && !wasSticky) {
        console.log(`🎯 Trigger ${index} is now sticky at rect.top: ${currentTop.toFixed(2)}px`);
        stickyMonitorState.lastStickyState.set(trigger, true);
        
        // Detectar el primer sticky
        if (!stickyMonitorState.firstStickyDetected) {
          stickyMonitorState.firstStickyDetected = true;
          stickyMonitorState.scrollYWhenFirstSticky = currentScrollY;
          stickyMonitorState.adjustmentMultiplier = 0;
          
          // Obtener la altura del image link
          const imageLinkHeightValue = getComputedStyle(document.documentElement).getPropertyValue('--image-link-height');
          stickyMonitorState.imageLinkHeight = parseFloat(imageLinkHeightValue);
          console.log(`📸 Primer trigger sticky. Image link height: ${stickyMonitorState.imageLinkHeight}px`);
        }
      } else if (!isSticky && wasSticky) {
        stickyMonitorState.lastStickyState.set(trigger, false);
      }
    });
    
    // Después del primer sticky, aplicar ajuste por cada --image-link-height scrolleado
    if (stickyMonitorState.firstStickyDetected && stickyMonitorState.imageLinkHeight > 0) {
      const scrolledSinceFirstSticky = currentScrollY - stickyMonitorState.scrollYWhenFirstSticky;
      const newMultiplier = Math.floor(scrolledSinceFirstSticky / stickyMonitorState.imageLinkHeight);
      
      if (newMultiplier > stickyMonitorState.adjustmentMultiplier) {
        const adjustmentCount = newMultiplier - stickyMonitorState.adjustmentMultiplier;
        console.log(`📐 scrolledSinceFirstSticky: ${scrolledSinceFirstSticky}px | imageLinkHeight: ${stickyMonitorState.imageLinkHeight}px | newMultiplier: ${newMultiplier} | oldMultiplier: ${stickyMonitorState.adjustmentMultiplier} → Aplicando -15px × ${adjustmentCount}`);
        adjustCollectionShopInfo(-15 * adjustmentCount);
        stickyMonitorState.adjustmentMultiplier = newMultiplier;
      }
    }
    
    stickyMonitorState.lastScrollY = currentScrollY;
  }

  // Primera verificación
  checkTriggersSticky();
}

function adjustCollectionShopInfo(adjustment) {
  const infos = document.querySelectorAll('.collection-shop-info');
  
  infos.forEach((info) => {
    const topValue = info.style.top;
    const currentTop = parseFloat(topValue);
    const newTop = currentTop + adjustment;
    info.style.top = newTop + 'px';
  });
}

function monitorFooterTransform() {
  let footerTransformActive = false;
  let transformStartScrollY = 0;
  let lastScrollY = window.scrollY;
  
  function checkFooterTransform() {
    const footer = document.querySelector('#footer');
    const container = document.querySelector('#collections-shop-container');
  
    if (!footer || !container) return;
    
    // Obtener la mitad del viewport
    const shopVpHeightValue = getComputedStyle(document.documentElement).getPropertyValue('--shop-vp-height');
    const viewportHeight = parseFloat(shopVpHeightValue);
    
    const footerRect = footer.getBoundingClientRect();
    const currentScrollY = window.scrollY;
    
    // Si el footer alcanza la mitad del viewport, iniciar transform
    if (footerRect.top <= viewportHeight && !footerTransformActive) {
      console.log(`📍 Footer en mitad del viewport (${viewportHeight}px) - Iniciando transform`);
      footerTransformActive = true;
      transformStartScrollY = currentScrollY;
    }
    
    // Si el footer vuelve a subir por encima de ese punto, desactivar
    if (footerRect.top > viewportHeight && footerTransformActive) {
      console.log('⬆️ Footer subió - Desactivando transform');
      footerTransformActive = false;
      container.style.transform = 'translateY(0px)';
    }
    
    // Aplicar transform mientras está activo
    if (footerTransformActive) {
      const scrollDelta = currentScrollY - transformStartScrollY;
      const transformValue = `translateY(-${scrollDelta * 2}px)`;
      container.style.transform = transformValue;
      console.log(`📦 #collections-shop-container: ${transformValue}`);
    }
    
    lastScrollY = currentScrollY;
  }
  
  window.addEventListener('scroll', checkFooterTransform, { passive: true });
  
  // Verificación inicial
  checkFooterTransform();
}

// Handle image loading errors gracefully
function initImageErrorHandling() {
  const images = document.querySelectorAll('.media[data-fallback-src]');
  
  images.forEach(function(img) {
    const fallbackSrc = img.getAttribute('data-fallback-src');
    
    if (fallbackSrc) {
      img.addEventListener('error', function() {
        // Prevent infinite loop
        if (this.src !== fallbackSrc) {
          this.src = fallbackSrc;
        }
      }, { once: true });
    }
  });
}

// Geolocation and Weather
let currentWeather = { temp: '--', description: '--' };

function updateDateTime() {
  const now = new Date();
  const laRochelleTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
  
  // Formato: Février 1, 11:45:18
  const monthName = laRochelleTime.toLocaleString('fr-FR', { month: 'long' });
  const monthCapitalized = monthName.charAt(0).toUpperCase() + monthName.slice(1);
  const day = laRochelleTime.getDate();
  const hours = String(laRochelleTime.getHours()).padStart(2, '0');
  const minutes = String(laRochelleTime.getMinutes()).padStart(2, '0');
  const seconds = String(laRochelleTime.getSeconds()).padStart(2, '0');
  
  const weatherShort = currentWeather.description.substring(0, 3); // Primeras 3 letras
  const fullText = `La Rochelle, ${currentWeather.temp}°C ${weatherShort}, ${monthCapitalized} ${day}, ${hours}:${minutes}:${seconds}`;
  
  const locationEl = document.getElementById('location-weather');
  if (locationEl) {
    locationEl.textContent = fullText;
  }
}

function getLocationAndWeather() {
  // Coordenadas de La Rochelle
  const lat = 46.1583;
  const lon = -1.1545;
  
  // Obtener el clima usando Open-Meteo
  fetch(`https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current=temperature_2m,weather_code,relative_humidity_2m&temperature_unit=celsius`)
    .then(response => response.json())
    .then(weatherData => {
      const current = weatherData.current;
      const temp = Math.round(current.temperature_2m);
      const weatherDesc = getWeatherDescription(current.weather_code);
      currentWeather = { temp: temp, description: weatherDesc };
      updateDateTime(); // Actualizar con el nuevo clima
    })
    .catch(error => {
      console.log('Erreur lors de l\'obtention du climat:', error);
      currentWeather = { temp: '--', description: '--' };
      updateDateTime();
    });
}

function getWeatherDescription(code) {
  const weatherCodes = {
    0: 'Dégagé',
    1: 'Partiellement nuageux',
    2: 'Nuageux',
    3: 'Très nuageux',
    45: 'Brouillard',
    48: 'Brouillard givre',
    51: 'Bruine légère',
    53: 'Bruine modérée',
    55: 'Bruine dense',
    61: 'Pluie légère',
    63: 'Pluie modérée',
    65: 'Pluie forte',
    71: 'Neige légère',
    73: 'Neige modérée',
    75: 'Neige forte',
    77: 'Grêle',
    80: 'Pluie légère',
    81: 'Pluie modérée',
    82: 'Pluie forte',
    85: 'Neige légère',
    86: 'Neige forte',
    95: 'Orage',
    96: 'Orage con grêle légère',
    99: 'Orage con grêle forte'
  };
  return weatherCodes[code] || 'Inconnu';
}

// Collections Index Hover Effect
function initCollectionsIndexHoverEffect() {
  const collectionsIndexContent = document.querySelector('.collections-index-content');
  
  if (!collectionsIndexContent) return;

  function setupCollectionsIndexHover() {
    const isDesktop = window.innerWidth > 820;
    const isMobile = window.innerWidth < 820;
    const currentContainers = collectionsIndexContent.querySelectorAll('.collection-index-container');

    // Recreate nodes to clear previous listeners before re-binding.
    currentContainers.forEach((container) => {
      const newContainer = container.cloneNode(true);
      container.parentNode.replaceChild(newContainer, container);
    });

    const refreshedContainers = collectionsIndexContent.querySelectorAll('.collection-index-container');

    collectionsIndexContent.classList.remove('hover-active');
    refreshedContainers.forEach((container) => {
      container.classList.remove('hover');
      container.classList.remove('active');
    });

    if (isMobile) {
      refreshedContainers.forEach((container) => {
        const titleHeading = container.querySelector('.collection-index-title h2');
        if (!titleHeading) return;

        titleHeading.addEventListener('click', function() {
          refreshedContainers.forEach((otherContainer) => {
            otherContainer.classList.remove('active');
          });
          container.classList.add('active');
        });
      });
      return;
    }

    refreshedContainers.forEach((container) => {
      container.addEventListener('mouseenter', function() {
        collectionsIndexContent.classList.add('hover-active');
        this.classList.add('hover');
      });
      
      container.addEventListener('mouseleave', function() {
        collectionsIndexContent.classList.remove('hover-active');
        this.classList.remove('hover');
      });
    });
  }

  setupCollectionsIndexHover();
  window.addEventListener('resize', setupCollectionsIndexHover);
}

function initCollectionsShopHoverEffect() {
  if (!document.querySelector('.collection-shop-info') || !document.querySelector('.collection-shop-image-link')) {
    return;
  }

  let cumulativeHeight = 0;
  
  function setLayout() {
    const infos = document.querySelectorAll('.collection-shop-info');
    const imageLinks = document.querySelectorAll('.collection-shop-image-link');
    
    // Calcular altura del image link
    calculateImageLinkHeight();
    
    cumulativeHeight = 10;
    infos.forEach((info, index) => {
      if (index > 0) {
        const prevInfo = infos[index - 1];
        cumulativeHeight += prevInfo.offsetHeight;
      }
      
      info.style.top = cumulativeHeight + 'px';
      
      if (imageLinks[index]) {
        const infoHeight = info.offsetHeight;
        imageLinks[index].style.transform = `translateY(-${infoHeight}px)`;
      }
    });
    
    // Aplicar la clase trigger basada en la altura del viewport
    applyShopInfoTriggerClass();
  }

  function setupListeners() {
    const isDesktop = window.innerWidth > 820;
    const infos = document.querySelectorAll('.collection-shop-info');
    const imageLinks = document.querySelectorAll('.collection-shop-image-link');
    const images = document.querySelectorAll('.collection-shop-image');

    // Remover listeners clonando
    infos.forEach((info) => {
      const newInfo = info.cloneNode(true);
      info.parentNode.replaceChild(newInfo, info);
    });

    imageLinks.forEach((link) => {
      const newLink = link.cloneNode(true);
      link.parentNode.replaceChild(newLink, link);
    });

    // Obtener elementos nuevamente
    const newInfos = document.querySelectorAll('.collection-shop-info');
    const newImageLinks = document.querySelectorAll('.collection-shop-image-link');
    const newImages = document.querySelectorAll('.collection-shop-image');

    if (isDesktop) {
      // Hover en desktop
      newInfos.forEach((info, index) => {
        info.addEventListener('mouseenter', function() {
          newImageLinks[index]?.classList.add('active');
          info.classList.add('active');
        });

        info.addEventListener('mouseleave', function() {
          newImageLinks[index]?.classList.remove('active');
          info.classList.remove('active');
        });
      });

      newImages.forEach((image) => {
        const imageLink = image.closest('.collection-shop-image-link');
        const imageLinkIndex = Array.from(newImageLinks).indexOf(imageLink);

        image.addEventListener('mouseenter', function() {
          newImageLinks[imageLinkIndex]?.classList.add('active');
          newInfos[imageLinkIndex]?.classList.add('active');
        });

        image.addEventListener('mouseleave', function() {
          newImageLinks[imageLinkIndex]?.classList.remove('active');
          newInfos[imageLinkIndex]?.classList.remove('active');
        });
      });
    } else {
      // Click en mobile
      newInfos.forEach((info, index) => {
        info.addEventListener('click', function(e) {
          e.preventDefault();
          newImageLinks[index]?.classList.add('active');
          info.classList.add('active');
        });
      });

      newImages.forEach((image) => {
        const imageLink = image.closest('.collection-shop-image-link');
        const imageLinkIndex = Array.from(newImageLinks).indexOf(imageLink);

        image.addEventListener('click', function(e) {
          e.preventDefault();
          newImageLinks[imageLinkIndex]?.classList.add('active');
          newInfos[imageLinkIndex]?.classList.add('active');
        });
      });
    }
  }

  setLayout();
  setupListeners();

  // Re-setup cuando redimensiona
  window.addEventListener('resize', function() {
    setLayout();
    setupListeners();
  });
}

function initTabs() {
  function activateTab(title) {
    const allTitles = document.querySelectorAll('.block-title');
    const allContents = document.querySelectorAll('.block-content');
    const tabIndex = title.getAttribute('data-tab');
    
    // Remover active de todos los títulos
    allTitles.forEach(t => t.classList.remove('active'));
    
    // Ocultar todos los p
    allContents.forEach(content => {
      const p = content.querySelector('p');
      if (p) {
        p.style.display = 'none';
      }
    });
    
    // Agregar active al título clickeado
    title.classList.add('active');
    
    // Mostrar solo el p que corresponde al tab clickeado
    const targetContent = document.querySelector(`[data-tab-content="${tabIndex}"]`);
    if (targetContent) {
      const p = targetContent.querySelector('p');
      if (p) {
        p.style.display = 'block';
      }
    }
  }

  function setupTabsListeners() {
    const isDesktop = window.innerWidth > 820;
    const allTitles = document.querySelectorAll('.block-title');
    const allContents = document.querySelectorAll('.block-content');

    // Remover listeners anteriores
    allTitles.forEach((title) => {
      const newTitle = title.cloneNode(true);
      title.parentNode.replaceChild(newTitle, title);
    });

    // Obtener títulos nuevamente
    const newTitles = document.querySelectorAll('.block-title');

    if (isDesktop) {
      // Hover en desktop: el último tab hovereado permanece activo
      newTitles.forEach((title) => {
        title.addEventListener('mouseenter', function() {
          activateTab(this);
        });
      });
    } else {
      // Click en mobile
      newTitles.forEach((title) => {
        title.addEventListener('click', function() {
          activateTab(this);
        });
      });
    }
  }

  // Al cargar: mostrar solo el primer p, ocultar los demás
  const allContents = document.querySelectorAll('.block-content');
  allContents.forEach((content, index) => {
    const p = content.querySelector('p');
    if (p) {
      if (index === 0) {
        p.style.display = 'block';
      } else {
        p.style.display = 'none';
      }
    }
  });
  
  // Marcar el primer título como activo al cargar
  const allTitles = document.querySelectorAll('.block-title');
  if (allTitles.length > 0) {
    allTitles[0].classList.add('active');
  }

  setupTabsListeners();

  // Re-setup cuando redimensiona
  window.addEventListener('resize', setupTabsListeners);
}

function initLocationWeather() {
  updateDateTime();
  getLocationAndWeather();
  
  // Actualizar hora cada segundo
  setInterval(updateDateTime, 1000);
  
  // Actualizar clima cada 10 minutos
  setInterval(getLocationAndWeather, 600000);
}

function initMegaMenu() {
  // Mega menu control (state via data-mega-menu-open; CSS handles visibility)
  const megaMenu = document.querySelector('[data-mega-menu]');
  const menuButton = document.getElementById('menu-button');
  const menuButtonMobile = document.getElementById('menu-button-mobile');
  const closeMegaMenuBtn = document.getElementById('close-mega-menu');

  function setMegaMenuOpen(open) {
    if (megaMenu) megaMenu.setAttribute('data-mega-menu-open', open ? 'true' : 'false');
  }

  function isMegaMenuOpen() {
    return megaMenu && megaMenu.getAttribute('data-mega-menu-open') === 'true';
  }

  if (menuButton) {
    menuButton.addEventListener('click', function(e) {
      e.preventDefault();
      setMegaMenuOpen(!isMegaMenuOpen());
    });
  }

  if (menuButtonMobile) {
    menuButtonMobile.addEventListener('click', function(e) {
      e.preventDefault();
      setMegaMenuOpen(!isMegaMenuOpen());
    });
  }

  if (closeMegaMenuBtn) {
    closeMegaMenuBtn.addEventListener('click', function(e) {
      e.preventDefault();
      setMegaMenuOpen(false);
    });
  }

  document.addEventListener('click', function(e) {
    if (isMegaMenuOpen() && megaMenu && !megaMenu.contains(e.target) && !menuButton?.contains(e.target) && !menuButtonMobile?.contains(e.target)) {
      setMegaMenuOpen(false);
    }
  });
}

function initFooterTabs() {
  // Tabs del collection footer
  function activateFooterTab(label, index) {
    const footerLabels = document.querySelectorAll('.collection-footer-label');
    const footerElements = document.querySelectorAll('.collection-footer-element');
    
    // Remover active de todos los labels
    footerLabels.forEach(l => l.classList.remove('active'));
    
    // Ocultar todos los elements
    footerElements.forEach(el => el.style.display = 'none');
    
    // Agregar active al label clickeado
    label.classList.add('active');
    
    // Mostrar el element correspondiente
    if (footerElements[index]) {
      footerElements[index].style.display = 'block';
    }
  }

  function setupFooterListeners() {
    const isDesktop = window.innerWidth > 820;
    const footerLabels = document.querySelectorAll('.collection-footer-label');
    const footerElements = document.querySelectorAll('.collection-footer-element');

    // Ocultar todos los elements
    footerElements.forEach(el => el.style.display = 'none');

    // Remover listeners anteriores
    footerLabels.forEach((label) => {
      const newLabel = label.cloneNode(true);
      label.parentNode.replaceChild(newLabel, label);
    });

    // Obtener labels nuevamente
    const newFooterLabels = document.querySelectorAll('.collection-footer-label');

    // Mostrar solo el primer element
    const footerElementsRefresh = document.querySelectorAll('.collection-footer-element');
    if (footerElementsRefresh[0]) {
      footerElementsRefresh[0].style.display = 'block';
    }

    if (isDesktop) {
      // Hover en desktop: el último tab hovereado permanece activo
      newFooterLabels.forEach((label, index) => {
        label.addEventListener('mouseenter', function() {
          activateFooterTab(this, index);
        });
      });
    } else {
      // Click en mobile
      newFooterLabels.forEach((label, index) => {
        label.addEventListener('click', function(e) {
          e.preventDefault();
          activateFooterTab(this, index);
        });
      });
    }
  }

  // Mostrar primer tab por defecto
  const firstLabel = document.querySelector('.collection-footer-label');
  const firstElement = document.querySelector('.collection-footer-element');
  if (firstLabel) firstLabel.classList.add('active');
  if (firstElement) {
    firstElement.style.display = 'block';
  } else {
    // Ocultar todos los demás
    const allElements = document.querySelectorAll('.collection-footer-element');
    allElements.forEach((el, idx) => {
      if (idx > 0) el.style.display = 'none';
    });
  }

  setupFooterListeners();

  // Re-setup cuando redimensiona
  window.addEventListener('resize', setupFooterListeners);
}

document.addEventListener('DOMContentLoaded', function() {
  // Calcular la altura del header y asignarla a la variable CSS
  handleSecondaryNav();
  setHeaderHeightVar();
  setViewportHeightVar();
  initLQIP();
  initImageErrorHandling();
  revealPage();
  initCollectionsIndexHoverEffect();
  initCollectionsShopHoverEffect();
  initTabs();
  initLocationWeather();
  initMegaMenu();
  initFooterTabs();
  applyShopInfoTriggerClass();
  monitorStickyTriggers();
  monitorFooterTransform();
  
  // Observar cambios en el DOM para inicializar LQIP en elementos cargados dinámicamente
  const observer = new MutationObserver(function(mutations) {
    initLQIP();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener('resize', function() {
    setHeaderHeightVar();
    setViewportHeightVar();
    applyShopInfoTriggerClass();
    monitorStickyTriggers();
  });

  window.addEventListener('pagehide', function(event) {
    if (!event.persisted) hidePage();
  });
});

